module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/internals/add-to-unscopables.js
// module id = 445
// module chunks = 0